import HeadersDetail from './HeadersDetail'
import CDialog from './CDialog'
import AlertLeave from '@/components/commun/AlertLeave'
import ConfirmationResiliation from './ConfirmationResiliation'
import ListeDocuments from './ListeDocuments'
import PdfApp from './PdfApp'

export default {
  install(Vue) {
    Vue.component('headers-detail', HeadersDetail)
    Vue.component('c-dialog', CDialog)
    Vue.component('alert-leave', AlertLeave)
    Vue.component('confirmation-resiliation', ConfirmationResiliation)
    Vue.component('liste-documents', ListeDocuments)
    Vue.component('pdf-app', PdfApp)
  },
}
